export const ROLE_ADMIN = 'admin';
export const ROLE_USER = 'user';

export const PERMISSION_USERS_EDIT_OTHER_USERS = 'users.edit_other_users';
export const PERMISSION_USERS_EDIT_SELF = 'users.edit_self';
export const PERMISSION_USERS_ADD_BASEUSER = 'users.add_baseuser';
export const PERMISSION_USERS_ADD_INVITE = 'users.add_invite';
export const PERMISSION_USERS_LIST_INVITE = 'users.list_invite';
export const PERMISSION_USERS_DELETE_BASEUSER = 'users.delete_baseuser';
export const PERMISSION_USERS_LIST_BASEUSER = 'users.list_baseuser';
export const PERMISSION_USERS_BACKOFFICE = 'users.backoffice';
export const PERMISSION_USERS_BACKOFFICE_GLOBAL = 'users.backoffice_global';

export const PERMISSION_GROUP_MAP = {
    "users.add_baseuser": [
        "admin",
        "user"
    ],
    "users.add_invite": [
        "admin",
        "user"
    ],
    "users.backoffice": [],
    "users.backoffice_global": [],
    "users.delete_baseuser": [
        "admin",
        "user"
    ],
    "users.edit_other_users": [
        "admin",
        "user"
    ],
    "users.edit_self": [
        "admin",
        "user"
    ],
    "users.list_baseuser": [
        "admin",
        "user"
    ],
    "users.list_invite": [
        "admin",
        "user"
    ]
};